<template>
  <div class="admin-login-bg">
    <div class="admin-login">
      <h3><b>九州云</b>后台管理系统</h3>
      <el-form :model="loginForm" status-icon :rules="rules" ref="loginForm">
        <el-form-item prop="mobile">
          <el-input v-model="loginForm.mobile" auto-complete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <div class="Verification">
          <el-form-item class=code prop="code">
            <div class="admin-login-code">
              <el-input type="text" v-model="loginForm.code" auto-complete="off" placeholder="请填写短信验证码" min-width="100px"></el-input>
              <el-button type="primary" v-show="sendAuthCode" class="forget" @click="getAuthCode">获取验证码</el-button>
              <el-button type="primary" v-show="!sendAuthCode" class="auth_text_blue" v-text="auth_time+' 秒后重新发送'"></el-button>
            </div>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="admin-login-button" type="primary" :loading="logining" :disabled="logining" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { RouteDefines } from '@/utils/defines'
import PassportApi from '@/api/passport';
export default {
  name: 'Login',
  data() {
    return {
      logining: false,
      sendAuthCode: true,
      auth_time: 0,
      loginForm: {
        mobile: '',
        code: ''
      },
      rules: {

      }
    }
  },
  methods: {
    login() {
      if (this.loginForm.mobile.length !== 11) {
        this.$message.error('请填写正确的手机号')
        return false;
      } else if (this.loginForm.code.length !== 4) {
        this.$message.error('请填写正确的验证')
        return false;
      } else {
        this.logining = true;
        try {
          this.$store.dispatch('login', this.loginForm).then(() => {
            this.$router.push({
              name: RouteDefines.ROUTER_NAME_HOME_DASHBOARD
            })
            this.logining = false;
          }).catch(error => {
            this.$message.error(error);
            this.logining = false;
          })
        } catch (error) {
          this.$message.error(error);
          this.logining = false;
          return false;
        }
      }
    },
    //  验证
    getAuthCode: function(val) {
      const mobile = this.loginForm.mobile
      if (mobile.length === 11) {
        PassportApi.sendSmsCode(mobile).then(res => {
          this.loginForm.code = res.data;
          this.sendAuthCode = false
          // 设置倒计时秒
          this.auth_time = 60
          var auth_timetimer = setInterval(() => {
            this.auth_time--
            if (this.auth_time <= 0) {
              this.sendAuthCode = true
              clearInterval(auth_timetimer)
            }
          }, 1000)
        }).catch(error => {
          console.log(error)
        })
      } else {
        if (this.loginForm.mobile.length !== 11) {
          this.$message.error('请填写正确的手机号')
          return false;
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/passport/login.vue